module.exports = __webpack_public_path__ + "img/aloneLivingOlder.9654100c.svg";